import type { CagedLetter } from '@theory/caged';
import styles from './CagedSelector.module.css';

const SHAPES: CagedLetter[] = ['C', 'A', 'G', 'E', 'D'];

interface Props {
  value?: CagedLetter | null;
  onChange: (next: CagedLetter | null) => void;
}

export function CagedSelector({ value, onChange }: Props) {
  return (
    <div className={styles.row} role="radiogroup" aria-label="CAGED shape">
      <button
        type="button"
        onClick={() => onChange(null)}
        aria-checked={!value}
        role="radio"
        className={!value ? styles.active : undefined}
      >
        All
      </button>
      {SHAPES.map((s) => (
        <button
          type="button"
          key={s}
          onClick={() => onChange(s)}
          aria-checked={value === s}
          role="radio"
          className={value === s ? styles.active : undefined}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
